import React from "react";
import "./AiPlaygroundWordmark.css";

export type AiPlaygroundWordmarkProps = React.HTMLAttributes<HTMLSpanElement>;

/** “AI” (royal), “ Fest ” (vivid), “2026” (olive), tokens come from `.ai-page`. */
export function AiPlaygroundWordmark({ className, ...rest }: AiPlaygroundWordmarkProps) {
  return (
    <span className={["ai-playground-wordmark", className].filter(Boolean).join(" ")} {...rest}>
      <span className="ai-playground-wordmark__ai">AI</span>
      <span className="ai-playground-wordmark__play"> Fest </span>
      <span className="ai-playground-wordmark__ground">2026</span>
    </span>
  );
}
